export default "__VITE_PUBLIC_ASSET__6fa94e96__"